import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-commercial-modal',
  templateUrl: './upgrade-commercial-modal.component.html',
  styleUrls: ['./upgrade-commercial-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeCommercialBannerComponent {
  @Input() companyId: string;

  constructor(
    public dialogRef: MatDialogRef<UpgradeCommercialBannerComponent>,
    private router: Router
  ) {}

  onUpgradeNow(): void {
    this.router.navigate(['/booking']);
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
